
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailOrder extends Vue {
    @Prop({default: { products: [] }})
    private order!: Order;

    private collapseFeeItem = {
        feeBuy: false,
        feeWeight: false
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get feeBuyOrigin() {
        return Math.round(this.order.feeBuy * (this.order.amountVND / 100));
    }

    get feeBuyDiscount() {
        return Math.round((this.feeBuyOrigin / 100) * (this.order.feeBuyDiscount || 0));
    }

    get feeWeightOrigin() {
        return (this.order.feeWeightAmount / (100 - this.order.feeWeightDiscount)) * 100;
    }

    get productsAmount() {
        return this.order.products.reduce((amount: number, prod: Product) => {
            return amount + (prod.quantity * (prod.pricePromotion || prod.priceOrigin));
        }, 0);
    }

    get deposit() {
        return this.order.deposit > 0 ? formatNumber(this.order.deposit, '0,0') + '' : 'Chưa đặt cọc';
    }

    get needPayment() {
        return this.order.totalAmountVND - (this.order.deposit || 0);
    }

    private shippingMethodDisplay(id) {
        if (this.shippingMethod) {
            const ret = this.shippingMethod.find(c => c.ID === id) || {ID: 0, Name: 'Tiêu chuẩn'};
            return ret.Name;
        }
        return 'Tiêu chuẩn';
    }

    get shippingMethod() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].shippingMethod;
    }

    private async getShippingMethod() {
        const result = await commonService.getShippingMethod();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SHIPPINGMETHOD', result.data.data);
        }
    }

    private async created() {
        if (!this.shippingMethod) {
            await this.getShippingMethod();
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async onCollapseFee(feeName: string) {
        this.collapseFeeItem[feeName] = !this.collapseFeeItem[feeName];
    }
}
